import firebase from 'firebase/app'
import 'firebase/auth'
// import 'firebase/analytics'

// The configuration below is not sensitive data. You can serenely add your config here
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBWVkB3NO3Cjs8RpjuQ3lhAUivQiop9e_E',
  authDomain: 'tempo-calculateur.firebaseapp.com',
  projectId: 'tempo-calculateur',
  storageBucket: 'tempo-calculateur.appspot.com',
  messagingSenderId: '1001884443991',
  appId: '1:1001884443991:web:cbb7bb93e003dec59aca12',
  measurementId: 'G-9L00LSMCXT'
};

firebase.initializeApp(firebaseConfig)
// firebase.analytics()
